module.exports = __webpack_public_path__ + "media/images/contact_1-340cd102177eb4cb1d1c50553e8cf863.svg";